module.exports = __webpack_public_path__ + "img/wukeshijiancha.e182b2e7.png";